import nextDynamic from 'next/dynamic';

const Content = nextDynamic(() => import('./marketplace-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
